import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import { TextInput } from 'components/patterns/Inputs'
import Editor from 'components/feature/Editor'
import strings from 'utils/strings'
import { FUNCTION_DESCRIPTION_MAX_LENGTH } from 'utils/constants'

import querySchema from 'schemas/validation/feature/querySchema'
import { schemaProp } from 'schemas/validation'

import withStyle from './FunctionEditor.style.js'
import FunctionNavList from '../FunctionNavList'

const rule = schemaProp(querySchema)

const FunctionEditor = ({
  fnId,
  description,
  updateDescription,
  toggleMarkForDeletion,
  markedForDeletion,
  deleteFunction,
  allDescriptions,
  children,
}) => {
  const savableDescription = `${description}`.substring(
    0,
    FUNCTION_DESCRIPTION_MAX_LENGTH - 1
  )

  return (
    <Editor
      toggleMarkForDeletion={toggleMarkForDeletion}
      markedForDeletion={markedForDeletion}
      deleteItem={deleteFunction}
      deleteHeaderText={strings.delete_item_heading(savableDescription)}
      deleteExplanation={strings.delete_function_warning_explaination}
      showClear={false}
    >
      {children}
      <TextInput
        required
        maxLength={80}
        rules={rule('description', {
          descriptions: allDescriptions,
        })}
        label={strings.function_name}
        name={strings.description}
        value={description}
        onChange={updateDescription}
      />
      <FunctionNavList id={fnId} />
    </Editor>
  )
}

FunctionEditor.defaultProps = {
  markedForDeletion: false,
}

FunctionEditor.propTypes = {
  description: PropTypes.string,
  updateDescription: PropTypes.func,
  fnId: PropTypes.string,
  deleteFunction: PropTypes.func,
  toggleMarkForDeletion: PropTypes.func,
  markedForDeletion: PropTypes.bool,
  allDescriptions: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
}

export default compose(withStyle)(FunctionEditor)
